import { createAsyncThunk } from '@reduxjs/toolkit';

import { sharedApi } from 'utils/api/api';
import formatDictionaryData from 'utils/formatDictionaryData';

import { DICT } from 'constants/endpoints';

export const fetchDictionary = createAsyncThunk(
  'dictionaries/fetchDictionary',
  async (
    { dict, locale }: { dict: string; locale?: string },
    { rejectWithValue }
  ) => {
    try {
      const query = locale ? `?locale=${encodeURIComponent(locale)}` : '';
      const response = await sharedApi.get(`${DICT}/${dict}${query}`);
      return {
        dict: response.name,
        data: formatDictionaryData(response.data)
      };
    } catch (error: any) {
      const serializableError = {
        message: error?.message || 'Unknown error',
        status: error?.status || 500,
        data: error?.data || null
      };
      return rejectWithValue(serializableError);
    }
  }
);

export const fetchDictionariesBatch = createAsyncThunk(
  'dictionaries/fetchDictionariesBatch',
  async (
    { dicts, locale }: { dicts: string[]; locale?: string },
    { rejectWithValue }
  ) => {
    try {
      const query = locale ? `&locale=${encodeURIComponent(locale)}` : '';
      const names = dicts.join(',');
      const response = await sharedApi.get(
        `${DICT}/list?name=${names}${query}`
      );

      return response.map((dict: { name: string; data: any }) => ({
        dict: dict.name,
        data: formatDictionaryData(dict.data)
      }));
    } catch (error: any) {
      const serializableError = {
        message: error?.message || 'Unknown error',
        status: error?.status || 500,
        data: error?.data || null
      };
      return rejectWithValue(serializableError);
    }
  }
);
